import { vuexTypes } from '../types'
import { usersService } from '@api/users.service'
import get from 'lodash/get'

function getInitialState () {
  return {
    email: '',
    createdAt: '',
    taurus: [],
    xpay: [],
    uplataInsha: [],
    locale: '',
    details: {
      favorites: []
    }
  }
}

export const state = getInitialState()

export const mutations = {
  SET_LOGGED_OUT_STATE (state) {
    Object.assign(state, getInitialState())
  },
  SET_USER_EMAIL (state, email) {
    state.email = email
  },
  SET_USER_CREATED_AT (state, createdAt) {
    state.createdAt = createdAt
  },
  SET_FAVORITES: (state, favorites) => {
    state.details.favorites = favorites
  },
  SET_USER_TAURUS: (state, taidRecords) => {
    state.taurus = taidRecords
  },
  SET_USER_XPAY: (state, xpayRecords) => {
    state.xpay = xpayRecords
  },

  SET_USER_UPLATA_INSHA: (state, uplataInshaRecords) => {
    state.uplataInsha = uplataInshaRecords
  },

  SET_LOCALE: (state, locale) => {
    state.locale = locale
  }
}

export const actions = {
  async GET_USER_DETAILS ({ commit }) {
    const userDetails = await usersService.loadUser()

    commit(vuexTypes.SET_USER_EMAIL, userDetails.attribute('email'))
    commit(vuexTypes.SET_USER_CREATED_AT, userDetails.attribute('created_at'))
  },

  async GET_USER_FAVORITES ({ commit }) {
    const response = await usersService.loadUserFavorites()
    const favorites = response
      .data()
      .map(item => ({id: get(item, 'data.id'), key: get(item, 'data.attributes.key')}))
    commit(vuexTypes.SET_FAVORITES, favorites)
  },

  async GET_USER_LOCALE ({ commit }) {
    const response = await usersService.loadUserLocale()
    if (response._parsedData.locale) {
      commit(vuexTypes.SET_LOCALE, response._parsedData.locale)
    } else {
      commit(vuexTypes.SET_LOCALE, 'en')
    }
  },

  async SET_USER_LOCALE ({ commit }, filter) {
    await usersService.updateUserLocale(filter)
    commit(vuexTypes.SET_LOCALE, filter)
  },

  async GET_USER_TAURUS ({ commit }) {
    try {
      commit(vuexTypes.SET_USER_TAURUS, await usersService.getTaurus())
    } catch (e) {
      console.log('TAURUS CARD ERROR', e)
    }
  },
  async GET_USER_XPAY ({ commit }) {
    try {
      commit(vuexTypes.SET_USER_XPAY, await usersService.getXpay())
    } catch (e) {
      console.log('ERROR', e)
    }
  },

  async GET_USER_UPLATA_INSHA ({ commit }) {
    try {
      commit(vuexTypes.SET_USER_UPLATA_INSHA, await usersService.getUplataInsha())
    } catch (e) {
      console.log('TAURUS CARD ERROR', e)
    }
  },
  async SET_USER_XPAY ({ commit }, xpayRecords) {
    const records = await usersService.updateXpay(xpayRecords)
    return records
  },
  async SET_USER_UPLATA_INSHA ({ commit }, uplataInshaRecords) {
    const records = await usersService.updateUplataInsha(uplataInshaRecords)
    commit(vuexTypes.SET_USER_UPLATA_INSHA, records)
  },

  async SET_USER_TAURUS ({ commit }, taurusRecords) {
    const records = await usersService.updateTaurus(taurusRecords)
    commit(vuexTypes.SET_USER_TAURUS, records)
  },

  async DELETE_USER_TAURUS ({ commit }, taurus) {
    const records = await usersService.deleteTaurus(taurus)
    commit(vuexTypes.SET_USER_TAURUS, records)
  },

  async DELETE_USER_UPLATA_INSHA ({ commit }, uplataInsha) {
    const records = await usersService.deleteUplataInsha(uplataInsha)
    commit(vuexTypes.SET_USER_UPLATA_INSHA, records)
  }
}

export const getters = {
  userEmail: state => state.email,
  userType: state => state.type,
  userCreatedAt: state => state.createdAt,
  userFavorites: state => state.details.favorites,
  userTaurus: state => state.taurus,
  userXpay: state => state.xpay,
  userUplataInsha: state => state.uplataInsha,
  getUserLocale: state => state.locale
}

export default {
  actions,
  getters,
  mutations,
  state
}



// WEBPACK FOOTER //
// ./src/vuex/modules/user.module.js